export const changeValueOfTime = (value, fieldName, id, setTime) => {
  setTime((prevTime) => {
    const updatedTime = [...prevTime];
    updatedTime[id] = { ...updatedTime[id], [fieldName]: `${value}` };
    return updatedTime;
  });
};
